//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/RoutingCommon.js";
import "../no/Builder.js";
let d=[[],[[["componentStrings"],"SetComponentsToRefresh",{},1,0],[["occurrence"],"RefreshPart",{R_:{reason:''}},1,0]],[]];
SPLM.RoutingCommon.LibraryRefreshBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.RoutingCommon.LibraryRefreshBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.RoutingCommon.LibraryRefreshBuilder.JaRoutingcommonRefreshLibraryBuilderRefreshStatus = Object.freeze({
    "RefreshSuccessful" : "RefreshSuccessful", "RefreshFailed" : "RefreshFailed", "RefreshFailedMultipleDefinitionsFound" : "RefreshFailedMultipleDefinitionsFound", "RefreshFailedNoDefinitionFound" : "RefreshFailedNoDefinitionFound", "RefreshFailedComponentNotLoaded" : "RefreshFailedComponentNotLoaded", "RefreshFailedRefrenceComponent" : "RefreshFailedRefrenceComponent"});

export default SPLM;